module.exports = __webpack_public_path__ + "static/media/Icon-02@2x.260e0414.png";